import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc24d4c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk" }
const _hoisted_2 = { class: "rk_list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["checked"]
const _hoisted_5 = { class: "rk_list_item_right" }
const _hoisted_6 = { class: "rk_list_item_right_bottom" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rk_zw" }, null, -1))
const _hoisted_8 = { class: "rk_footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认余留次班")
const _hoisted_10 = [
  _hoisted_9
]

import { ref, onMounted } from 'vue'
    import { useRouter, useRoute } from "vue-router"
    import { finishedInBill, finishedDetail } from '@/apis/WorkOrderAPI'
    import NoFound from '@/components/common/NotFound.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    const route = useRoute()

    let list = ref<Array<any>>([])

    // 点击项
    const clickItem = (index: number): void => {
        list.value[index].active = !list.value[index].active
    }

    // 获取余留次班
    const finishedInBills = () => {
        finishedInBill({
            inLocationIds: route.query.id
        }).then(res => {
            if (res.code === 200) {
                // console.log(res)
                // let data: any = route.query.ids
                // if (data) {
                //   let ids: any = data.split(',')
                //   if (ids.length > 0) {
                //     res.data.forEach((item: any, index: number) => {
                //       item.isactive = false
                //       ids.forEach((item1: any) => {
                //         if (item.id === Number(item1)) {
                //           res.data.splice(index, 1)
                //         }
                //       })
                //     })
                //   } else {
                    res.data.forEach((item: any) => {
                      item.isactive = false
                    })
                //   }
                // }
                list.value = res.data
            }
        })
    }

    // 提交
    const submit = () => {
        let ids: any = [];
        list.value.forEach((item: any) => {
            if (item.active) {
                ids.push(item.id)
            }
        })
        window.sessionStorage.setItem('ids', ids.join(','))
        router.go(-1)
    }

    onMounted(() => {
        finishedInBills()
    })

return (_ctx: any,_cache: any) => {
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(list) && _unref(list).length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(list), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "rk_list_item",
              key: index,
              onClick: ($event: any) => (clickItem(index))
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: item.active
              }, null, 8, _hoisted_4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(item.code) + " 转库入库", 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, "接收人：" + _toDisplayString(item.userName), 1),
                  _createElementVNode("span", null, "入库时间：" + _toDisplayString(item.dealDate), 1)
                ])
              ])
            ], 8, _hoisted_3))
          }), 128))
        : (_openBlock(), _createBlock(NoFound, { key: 1 }))
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "rk_footer_submit",
        onClick: submit
      }, _hoisted_10)), [
        [_directive_preventReClick]
      ])
    ])
  ]))
}
}

})